import React from "react"
import "./team.css"

const strengths = [
  { icon: "fa fa-chart-line",    text: "Technical & Price Action Analysis" },
  { icon: "fa fa-shield-alt",    text: "Risk Management & Position Sizing" },
  { icon: "fa fa-brain",         text: "Trading Psychology & Behavioral Coaching" },
  { icon: "fa fa-cogs",          text: "Developing Repeatable, Rule-Based Strategies" },
  { icon: "fa fa-user-graduate", text: "Mentoring Beginners to Consistency" },
]

const roles = [
  "Designs and updates all trading curricula — Beginner to Professional.",
  "Leads live trading sessions and market reviews.",
  "Mentors advanced students in one-on-one coaching.",
  "Ensures all educational content aligns with real market conditions.",
]

const TeamCard = () => {
  return (
    <div className="founder-full-card">

      {/* ── Top header strip ── */}
      <div className="founder-card-header">
        <div className="founder-avatar">
          <i className="fa fa-user-tie"></i>
        </div>
        <div className="founder-card-title">
          <span className="founder-tag">FOUNDER &amp; HEAD OF TRADING EDUCATION</span>
          <h2>Mr. Ali</h2>
          <p className="founder-sub">Rovers Access Limited · Nairobi, Kenya</p>
        </div>
        <div className="founder-socials">
          <a href="#" className="fsocial"><i className="fab fa-linkedin-in"></i></a>
          <a href="#" className="fsocial"><i className="fab fa-twitter"></i></a>
          <a href="#" className="fsocial"><i className="fab fa-instagram"></i></a>
          <a href="#" className="fsocial"><i className="fab fa-facebook-f"></i></a>
        </div>
      </div>

      {/* ── Body ── */}
      <div className="founder-card-body">

        {/* Left column */}
        <div className="founder-left">

          {/* Background */}
          <div className="founder-section">
            <h4><i className="fa fa-id-badge"></i> Background</h4>
            <p>
              Mr. Ali has over a <strong>decade of active experience</strong> in global financial
              markets, specialising in Forex, Commodities, and Indices. He began trading personally,
              faced the steep learning curve of losses and wins, and developed a disciplined,
              risk-first methodology.
            </p>
            <p>
              Frustrated by the lack of genuine, practical trading education in Kenya, he founded
              Rovers Access Limited to fill that gap with a curriculum grounded in real market
              knowledge — not hype.
            </p>
          </div>

          {/* Philosophy */}
          <div className="founder-section">
            <h4><i className="fa fa-lightbulb"></i> Philosophy</h4>
            <blockquote className="founder-philosophy">
              "Most trading courses teach you what to look at. We teach you what to actually
              do — and, more importantly, what <em>not</em> to do."
            </blockquote>
          </div>

          {/* Day-to-day role */}
          <div className="founder-section">
            <h4><i className="fa fa-tasks"></i> Day-to-Day Role at Rovers Access</h4>
            <ul className="founder-role-list">
              {roles.map((r, i) => (
                <li key={i}>
                  <i className="fa fa-check-circle"></i>
                  <span>{r}</span>
                </li>
              ))}
            </ul>
          </div>

        </div>

        {/* Right column */}
        <div className="founder-right">

          {/* Key Strengths */}
          <div className="founder-section">
            <h4><i className="fa fa-star"></i> Key Strengths</h4>
            <div className="founder-strengths">
              {strengths.map((s, i) => (
                <div className="strength-item" key={i}>
                  <div className="strength-icon"><i className={s.icon}></i></div>
                  <span>{s.text}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Signature quote card */}
          <div className="founder-quote-card">
            <div className="quote-mark"><i className="fa fa-quote-left"></i></div>
            <p>
              Discipline beats conviction every time. Master your risk, and the profits
              will follow.
            </p>
            <div className="quote-author">
              <div className="quote-author-avatar"><i className="fa fa-user-tie"></i></div>
              <div>
                <strong>Mr. Ali</strong>
                <span>Founder, Rovers Access Limited</span>
              </div>
            </div>
          </div>

          {/* Stats */}
          <div className="founder-stats">
            <div className="fstat">
              <h3>10+</h3>
              <p>Years Trading</p>
            </div>
            <div className="fstat">
              <h3>1,200+</h3>
              <p>Students Trained</p>
            </div>
            <div className="fstat">
              <h3>4</h3>
              <p>Programmes</p>
            </div>
          </div>

        </div>
      </div>

      {/* ── Coming soon strip ── */}
      <div className="team-coming-soon">
        <i className="fa fa-users"></i>
        <span>More team members coming soon — we are growing!</span>
      </div>

    </div>
  )
}

export default TeamCard
